(() => {
let $1df32a4945e9e156$var$expandBtns = [];
let $1df32a4945e9e156$var$expandedElms = [];
let $1df32a4945e9e156$var$expand = null;
let $1df32a4945e9e156$var$overlay = null;
let $1df32a4945e9e156$var$subNodeExpandBtns = [];
let $1df32a4945e9e156$var$headerSearch = null;
let $1df32a4945e9e156$var$headerSearchForm = null;
let $1df32a4945e9e156$var$searchForm = [];
let $1df32a4945e9e156$var$searchInput = [];
let $1df32a4945e9e156$var$searchClear = [];
let $1df32a4945e9e156$var$headerSearchEscPressed = 0;
let $1df32a4945e9e156$var$headerSearchOtherKeysPressed = 0;
window.addEventListener("load", (e)=>{
    loadSVGSpritesheet();
    $1df32a4945e9e156$var$expandBtns = document.querySelectorAll("[data-expand]");
    $1df32a4945e9e156$var$overlay = document.getElementById("overlay");
    $1df32a4945e9e156$var$subNodeExpandBtns = document.querySelectorAll("[data-expand-subnode]");
    /*Jump to content*/ /*Jump to main content*/ let main = document.querySelectorAll("main");
    let focusable = main[0].querySelectorAll("#contentSelectorTypeOpener, #contentSelectorSubjectOpener, button, [href], select, textarea");
    let firstFocusable = focusable[0];
    let jumpToContent = document.getElementById("jumpToContent");
    jumpToContent.addEventListener("click", function() {
        firstFocusable.focus();
    });
    /*Search */ $1df32a4945e9e156$var$headerSearch = document.getElementById("searchHeader");
    $1df32a4945e9e156$var$searchInput = document.querySelectorAll("input[type=search]");
    $1df32a4945e9e156$var$searchForm = document.getElementsByClassName("search-form");
    $1df32a4945e9e156$var$searchClear = document.getElementsByClassName("clear-search");
    searchInit();
    //Clear input
    for(let i = 0; i < $1df32a4945e9e156$var$searchClear.length; i++)$1df32a4945e9e156$var$searchClear[i].addEventListener("click", function(e) {
        clearInput(e.currentTarget);
    });
    function clearInput(btn) {
        let clearInput = document.getElementById(btn.dataset.clearSearch);
        clearInput.value = "";
        btn.classList.add("hidden");
        clearInput.focus();
    }
    // Prevent submitting empty search field
    for(let i = 0; i < $1df32a4945e9e156$var$searchForm.length; i++)$1df32a4945e9e156$var$searchForm[i].addEventListener("submit", function(e) {
        let formValue = e.currentTarget.getElementsByTagName("input");
        if (formValue[0].value == null || formValue[0].value.length == 0) e.preventDefault();
    });
    /* Overlay - hide and close all expanded */ $1df32a4945e9e156$var$overlay.addEventListener("click", function(e) {
        $1df32a4945e9e156$var$overlay.classList.add("hidden");
        $1df32a4945e9e156$var$headerSearch.blur();
        for(let i = 0; i < $1df32a4945e9e156$var$expandedElms.length; i++){
            $1df32a4945e9e156$var$expandedElms[i].setAttribute("aria-hidden", "true");
            $1df32a4945e9e156$var$expandedElms[i].classList.remove("expanded");
        }
        for(let i = 0; i < btnElms.length; i++)btnElms[i].classList.remove("primary-active");
        $1df32a4945e9e156$var$headerSearchEscPressed = 0;
        $1df32a4945e9e156$var$headerSearchOtherKeysPressed = 0;
    });
    /*Expand subnode navigation*/ for(let i = 0; i < $1df32a4945e9e156$var$subNodeExpandBtns.length; i++)$1df32a4945e9e156$var$subNodeExpandBtns[i].addEventListener("click", function(e) {
        toggleExpandBtn(e.currentTarget, "sub-btn-active");
        // toggleExpandBtn(e.currentTarget, "sub-btn-active");
        // .setAttribute("aria-hidden", "true");
        expandElm(e.currentTarget.parentElement.parentElement.querySelector("ul"), "subnodes-expanded");
    });
    /*Expand header elements*/ for(let i = 0; i < $1df32a4945e9e156$var$expandBtns.length; i++)$1df32a4945e9e156$var$expandBtns[i].addEventListener("click", function(e) {
        $1df32a4945e9e156$var$expandedElms = document.getElementsByClassName("expanded");
        $1df32a4945e9e156$var$expand = document.getElementById(e.currentTarget.dataset.expand);
        btnElms = document.getElementsByClassName("primary-active");
        let btn = e.currentTarget;
        if ($1df32a4945e9e156$var$expand.classList.contains("expanded") == true) {
            for(let i = 0; i < btnElms.length; i++)btnElms[i].classList.remove("primary-active");
            for(let i = 0; i < $1df32a4945e9e156$var$expandedElms.length; i++){
                $1df32a4945e9e156$var$expandedElms[i].setAttribute("aria-hidden", "true");
                $1df32a4945e9e156$var$expandedElms[i].classList.remove("expanded");
            }
            $1df32a4945e9e156$var$headerSearch.blur();
            $1df32a4945e9e156$var$overlay.classList.add("hidden");
        } else {
            for(let i = 0; i < $1df32a4945e9e156$var$expandedElms.length; i++){
                $1df32a4945e9e156$var$expandedElms[i].setAttribute("aria-hidden", "true");
                $1df32a4945e9e156$var$expandedElms[i].classList.remove("expanded");
            }
            for(let i = 0; i < btnElms.length; i++)btnElms[i].classList.remove("primary-active");
            $1df32a4945e9e156$var$overlay.classList.remove("hidden");
            btn.classList.add("primary-active");
            $1df32a4945e9e156$var$expand.classList.add("expanded");
            $1df32a4945e9e156$var$expand.setAttribute("aria-hidden", "false");
            if (btn.dataset.expand == "search") $1df32a4945e9e156$var$headerSearch.focus();
            if (btn.dataset.expand == "moreNav") {
                let moreNav = document.getElementById("moreNav");
                moreNav.addEventListener("focusout", function(e) {
                    if (!moreNav.contains(e.relatedTarget)) $1df32a4945e9e156$var$expandBtns[1].focus();
                });
                escapeInit();
            }
        }
    });
    function loadSVGSpritesheet() {
        var request = new XMLHttpRequest();
        request.open("GET", "/images/spritesheet.svg?v=2");
        request.send();
        request.onreadystatechange = function() {
            if (request.readyState == XMLHttpRequest.DONE) {
                if (request.status == 200) {
                    var data = request.responseText;
                    var svgContainer = document.getElementById("svg-icons");
                    svgContainer.innerHTML = data;
                } else console.error("Couldn't load SVG spritesheet");
            }
        };
    }
    function searchInit() {
        let searchLastElm = document.getElementById("searchHeaderForm").querySelectorAll("input[type=submit]");
        searchLastElm[0].addEventListener("focusout", function(e) {
            $1df32a4945e9e156$var$expandBtns[0].focus();
        });
        // Add listner to search inputs
        for(let i = 0; i < $1df32a4945e9e156$var$searchInput.length; i++){
            $1df32a4945e9e156$var$searchInput[i].addEventListener("input", function(e) {
                handleClear(e.currentTarget.parentElement.querySelectorAll("[data-clear-search]"), e.currentTarget.value);
            });
            $1df32a4945e9e156$var$searchInput[i].addEventListener("keyup", function(e) {
                if (e.currentTarget.id === "searchHeader" && e.key !== "Escape" && e.key !== "Enter") $1df32a4945e9e156$var$headerSearchOtherKeysPressed++;
                if (e.currentTarget.id === "searchHeader" && e.key === "Escape") {
                    $1df32a4945e9e156$var$headerSearchEscPressed++;
                    if ($1df32a4945e9e156$var$headerSearchEscPressed == 2) {
                        e.currentTarget.blur();
                        $1df32a4945e9e156$var$overlay.click();
                        $1df32a4945e9e156$var$expandBtns[0].focus();
                    }
                    if ($1df32a4945e9e156$var$headerSearchEscPressed == 1 && $1df32a4945e9e156$var$headerSearchOtherKeysPressed == 0) {
                        e.currentTarget.blur();
                        $1df32a4945e9e156$var$overlay.click();
                        $1df32a4945e9e156$var$expandBtns[0].focus();
                    }
                }
            });
        }
    }
    function escapeInit() {
        document.onkeydown = function(e) {
            e = e || window.e;
            if (e.key == "Escape" && $1df32a4945e9e156$var$headerSearchOtherKeysPressed == 0 && $1df32a4945e9e156$var$headerSearchEscPressed == 0) $1df32a4945e9e156$var$overlay.click();
        };
    }
    function handleClear(btn, value) {
        if (value == "") btn[0].classList.add("hidden");
        else btn[0].classList.remove("hidden");
    }
    function expandElm(expand, expandClass) {
        if (expand.classList.contains(expandClass)) {
            expand.classList.remove(expandClass);
            expand.setAttribute("aria-hidden", "true");
        } else {
            expand.classList.add(expandClass);
            expand.setAttribute("aria-hidden", "false");
        }
    }
    function toggleExpandBtn(btn, btnActive) {
        btn.classList.toggle(btnActive);
    }
});
window.addEventListener("CookiebotOnDialogDisplay", function() {
    let dialog = document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper");
    let dialogFocusable = dialog.querySelectorAll("a");
    dialogFocusable[0].focus();
});

})();
//# sourceMappingURL=script.js.map
